import React from "react";
import Slider from "react-slick";

const sliderItems = [
  {
    imgSrc: require("../../assets/images/pages/usp/usp_1.svg").default,
    altText: "GPS enabled for realtime tracking",
    title: "GPS enabled for realtime tracking",
  },
  {
    imgSrc: require("../../assets/images/pages/usp/usp_2.svg").default,
    altText: "ACCURATE playing distances",
    title: "ACCURATE playing distances",
  },
  {
    imgSrc: require("../../assets/images/pages/usp/usp_3.svg").default,
    altText: "Connect with a Golfing community",
    title: "Connect with a Golfing community",
  },
  {
    imgSrc: require("../../assets/images/pages/usp/usp_4.svg").default,
    altText: "View game history and stats data",
    title: "View game history and stats data",
  },
];

const Usp = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 560,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="section-p usp_wrapper">
      <div className="page-width">
        <div className="usp">
          <Slider {...settings} className="usp__section">
            {sliderItems.map((item, index) => (
              <div className="usp__section-box" key={index}>
                <img src={item.imgSrc} alt={item.altText} />
                <h1 className="text-jost-sb-22">{item.title}</h1>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Usp;
